import WebService from "../WebService";
const Report = {
  overview(params) {
    return WebService.get("/report/overview?" + params);
  },
  campaign(params) {
    return WebService.get("/report/campaign?" + params);
  },
  source(params) {
    return WebService.get("/report/source?" + params);
  },
  content(params) {
    return WebService.get("/report/content?" + params);
  },
  ticket(params) {
    return WebService.get("/report/ticket?" + params);
  },
  referrer(params) {
    return WebService.get("/report/referrer?" + params);
  },
  promocode(params) {
    return WebService.get("/report/promocode?" + params);
  },
  communication(params) {
    return WebService.get("/report/communication?" + params);
  },
  engagement(params) {
    return WebService.get("/report/contest/engagements?" + params);
  },
  checkinTickets(params) {
    return WebService.get("/checkin/tickets?" + params);
  },
  checkinStats(params) {
    return WebService.get("/checkin/status?" + params);
  },
  checkinReportGroup(params) {
    return WebService.get("/checkin/report-groups?" + params);
  },
  checkinReportDays(params) {
    return WebService.get("/checkin/report-days?" + params);
  },
  register(params) {
    return WebService.get("/report/register?" + params);
  },
  sales(params) {
    return WebService.get("/report/sales?" + params);
  },
  voteSummary(params) {
    return WebService.get("/report/vote-summary?" + params);
  },
  voteSummaryCandidate(params) {
    return WebService.get("/report/candidate-summary?" + params);
  },
  checkinDetail(params) {
    return WebService.get("/report/checkedin?" + params);
  },
  sector(params) {
    return WebService.get("/report/sector?" + params);
  },
  rsvp(params) {
    return WebService.get("/report/rsvp?" + params);
  },
  registration(params) {
    return WebService.get("/report/registration?" + params);
  },
};
export default Report;
